import type { ScriptProps } from 'next/script';

/**
 * Maps parsed `<script>` attributes to props next/script accepts on the underlying element.
 */
export function scriptAttributesToScriptProps(
  attributes: Record<string, string>,
): Partial<ScriptProps> {
  const props: Record<string, string | boolean | undefined> = {};

  for (const [rawKey, value] of Object.entries(attributes)) {
    const key = rawKey.toLowerCase();
    if (key === 'src') continue;

    switch (key) {
      case 'async':
        props.async = value === '' || value === 'async' || value === 'true';
        break;
      case 'defer':
        props.defer = value === '' || value === 'defer' || value === 'true';
        break;
      case 'crossorigin':
        props.crossOrigin = value === '' ? 'anonymous' : value;
        break;
      case 'referrerpolicy':
        props.referrerPolicy = value;
        break;
      case 'integrity':
        props.integrity = value;
        break;
      case 'nonce':
        props.nonce = value;
        break;
      case 'id':
        props.id = value;
        break;
      case 'type':
        props.type = value;
        break;
      case 'charset':
        props.charSet = value;
        break;
      case 'nomodule':
        props.noModule = value === '' || value === 'true' || value === 'nomodule';
        break;
      default:
        if (key.startsWith('data-')) {
          props[rawKey] = value;
        }
        break;
    }
  }

  return props as Partial<ScriptProps>;
}
